import React from 'react';
import { toArray } from 'lodash';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';
import { STATIC_ROOT, BRAND_NAME } from '../../../constants';

import { hasCashback } from '../../../services/partner/utils';
import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

import SvgComponent from '../../SvgComponent';
import { HeadComponent } from '../../HeadComponent';
import { withTemplate } from '../../template/withTemplate';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import LocalizedBreadcrumbItem from '../../breadcrumb/LocalizedBreadcrumbsItem';

import './ToolbarPage.scss';

export class ToolbarInstallationPage extends React.Component {
    render() {
        const { i18n, partners } = this.props;
        return (
            <main className="conteneur conteneur-mobile" id="p-toolbar">
                <HeadComponent title={i18n.TITLE} description={i18n.DESCRIPTION} />
                <LocalizedBreadcrumbItem to={PATH.TOOLBAR_POST_INSTALL_PATH}>
                    {i18n.BREADCRUMB}
                </LocalizedBreadcrumbItem>
                <h1>{convertHtmlToReactDomWithParams(i18n.PAGE_TITLE, BRAND_NAME)}</h1>
                <div className="installation">
                    <h3>
                        <SvgComponent
                            src={`${STATIC_ROOT}/toolbars/toolbar_check.svg`}
                            width="17"
                            height="17"
                        />
                        {i18n.INSTALLATION_TEXT1}
                    </h3>
                    <p>{convertHtmlToReactDomWithParams(i18n.INSTALLATION_TEXT2, partners)}</p>
                </div>
                <h3 className="sectionTitle">
                    {convertHtmlToReactDomWithParams(i18n.INSTALLATION_SECTION_TITLE, BRAND_NAME)}
                </h3>
                <div className="explanationContainer">
                    <div className="explanationBloc">
                        <p>{convertHtmlToReactDomWithParams(i18n.TEXT3)}</p>
                        <img
                            src={`${STATIC_ROOT}/toolbars/toolbar-bloc1.png`}
                            width="318"
                            height="155"
                            alt="toolbar"
                        />
                    </div>
                    <div className="explanationBloc">
                        <p>{convertHtmlToReactDomWithParams(i18n.TEXT4)}</p>
                        <img
                            src={`${STATIC_ROOT}/toolbars/toolbar-bloc2.png`}
                            width="318"
                            height="155"
                            alt="toolbar"
                        />
                    </div>
                    <div className="explanationBloc">
                        <p>{convertHtmlToReactDomWithParams(i18n.TEXT5, BRAND_NAME)}</p>
                        <img
                            src={`${STATIC_ROOT}/toolbars/toolbar-bloc3.png`}
                            width="318"
                            height="155"
                            alt="toolbar"
                        />
                    </div>
                </div>
                <div className="footer">
                    <p>{i18n.FOOTER_TEXT}</p>
                </div>
            </main>
        );
    }
}

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.TOOLBAR,
        partners: toArray(state.partner.partners).filter(partner => hasCashback(partner)).length
    };
};

export default withTemplate(connect(mapStateToProps)(ToolbarInstallationPage), PrimaryTemplate);



// WEBPACK FOOTER //
// ./src/components/pages/toolbar/ToolbarInstallationPage.js